import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis';
import '../css/app.css';

import { initNavigation } from './modules/navigation.js';
import { initSmoothScroll } from './modules/smooth-scroll.js';
import { initRevealAnimations } from './modules/animations.js';
import { initThemeMode } from './modules/theme-mode.js';
import { initSingleJournal } from './modules/single-journal.js';
import { initJournalArchive } from './modules/journal-archive.js';
import { initProjectsArchive } from './modules/projects-archive.js';
import { initSingleProject } from './modules/single-project.js';
import { initStudioPage } from './modules/studio.js';
import { initCityExplorers } from './modules/city-explorer.js';
import { initHomePage } from './modules/home.js';
import { initFooterReveal } from './modules/footer-reveal.js';
import { initContactMap } from './modules/contact-map.js';

gsap.registerPlugin(ScrollTrigger);

const boot = () => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const themeMode = initThemeMode();
    const lenis = initSmoothScroll({ gsap, ScrollTrigger, Lenis, reducedMotion });

    initNavigation({ lenis, gsap, reducedMotion });
    initRevealAnimations({ gsap, ScrollTrigger, reducedMotion });
    initSingleJournal({ lenis, gsap, ScrollTrigger, reducedMotion });
    initJournalArchive({ gsap, ScrollTrigger, reducedMotion });
    initProjectsArchive({ gsap, ScrollTrigger, reducedMotion, lenis });
    initSingleProject({ lenis, gsap, ScrollTrigger, reducedMotion });
    initStudioPage({ gsap, ScrollTrigger, lenis, reducedMotion });
    initCityExplorers({ lenis });
    initHomePage({ gsap, ScrollTrigger, reducedMotion });
    const contactMap = initContactMap();
    const footerReveal = initFooterReveal({ ScrollTrigger, lenis });

    window.LED = {
        gsap,
        ScrollTrigger,
        lenis,
        themeMode,
        footerReveal,
        contactMap,
        refresh: () => ScrollTrigger.refresh(),
    };

    window.addEventListener('led:themechange', (event) => {
        if (!event.detail?.animated) ScrollTrigger.refresh();
    });
    window.addEventListener('led:themetransitionend', () => ScrollTrigger.refresh());
    window.dispatchEvent(new CustomEvent('led:ready', { detail: window.LED }));
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
    boot();
}
